/** Public support and privacy contact approved by the product owner. */
export const SUPPORT_EMAIL = 'oberdan@cybrainx.com';
//# sourceMappingURL=contact.js.map